module.exports = __webpack_public_path__ + "static/media/78.70edd887.mp3";